<template>
    <div class="statiscal-container">
      <div class="tab-content">
        <div class="sabbatical-count">
          <img src="../../../public/img/icons/Group.svg" class="sabbatical_i" /> {{$t("fields.sabbatical.sabbatical_remaining_leave")}}
          <span>{{ expireSabbaticalLeave.number_of_days_leave }} </span>{{$t("fields.sabbatical.sabbatical_day")}}
        </div>
      </div>
      <div class="title">{{$t("page_title.page_sabbatical_leave_statistical")}}</div>
      <div class="tabs-control">
        <ul class="list-tabs">
          <li :class="0==currentTab ? 'active' : ''" @click="changeTab(0)">
            {{$t("fields.sabbatical.label_history_sabbatical")}}
          </li>
          <li :class="1==currentTab ? 'active' : ''" @click="changeTab(1)">
            {{$t("fields.sabbatical.label_expire_sabbatical")}}
          </li>
        </ul>
      </div>
      <KeepAlive>
        <component :is="listTabs[currentTab].name" />
      </KeepAlive>
    </div>
  </template>
  <script>
  import { mapActions, mapGetters } from "vuex";
  import HistorySabbatical from "./components/HistorySabbatical.vue"
  import ExpireSabbatical from "./components/ExpireSabbatical.vue"
  export default {
    name: "Sabbatical",
    metaInfo() {
      return {
        title: this.$t("page_title.page_sabbatical_leave_statistical"),
        titleTemplate: "%s | " + this.$t("page_title.head_title"),
      };
    },
    data() {
      return {
        listTabs: [
          {
            name: "HistorySabbatical",
            title: this.$t("fields.sabbatical.label_history_sabbatical"),
          },
          {
            name: "ExpireSabbatical",
            title: this.$t("fields.sabbatical.label_expire_sabbatical"),
          },
        ],
        currentTab: 0,
      };
    },
    components: {
      HistorySabbatical,
      ExpireSabbatical
    },
    computed: {
      ...mapGetters({
        expireSabbaticalLeave: "sabbatical-leave-request/expireSabbaticalLeave",
      }),
    },
    methods: {
      ...mapActions("layout", ["setLoading"]),
      changeTab(tab) {
        this.currentTab = tab;
      },
      async getExpireSabbaticalLeave() {
        let sabbaticalRequestId = this.$route.params.id;
        await this.$store.dispatch("sabbatical-leave-request/getExpireSabbaticalLeave",sabbaticalRequestId);
      },
    },
    async created() {
      await this.getExpireSabbaticalLeave();
    },
    destroyed() {
      this.$store.dispatch("sabbatical-leave-request/clearData")
    },
    watch: {},
  };
  </script>
  <style lang="scss" scoped>
    .statiscal-container {
    padding: 20px 20px;
    margin-top: -10px;
    .title {
      font-size: 22px;
      font-weight: 700;
      margin-bottom: 14px;
    }
    .tabs-control {
      border-bottom: 1px solid #DDE2E5;
      font-weight: 400;
      font-size: 16px;
      ul {
        list-style-type: none;
        text-align: center;
        align-items: center;
        padding-left: 0px;
        margin-bottom: 0px;
        display: flex;
        color: #1F2D3D;
        li {
          padding: 15px;
          margin-right: 15px;
          cursor: pointer;
        };
        .active {
          background-color:  rgba(17, 143, 166, 0.1);
          color: #118FA6;
          font-weight: 500;
          border-bottom: 2px solid #118FA6;
        }
      }
    }
    .tab-content {
      padding: 0 0 30px;
      .sabbatical-count {
        text-align: center;
        background-color: #118fa61a;
        padding: 5px 20px;
        border: 2px solid #118fa6;
        border-radius: 16px;
        font-weight: 500;
        font-size: 16px;
        color: #1F2D3D;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        .sabbatical_i {
          margin-right: 5px;
        }
        span {
          color: #118FA6;
          font-size: 28px;
          font-weight: bold;
          margin: 0px 5px 8px 5px;
        }
      }
    }
  }
  </style>
  